import React, { useContext } from 'react';
import { FaUser } from 'react-icons/fa';
import { Container, Usuario, LoginUsuario, Icon, Info } from './styles';
import Context, { IContext } from '../../context/Context';

export default function UsuarioInfo() {
  const { dadosUsuario, empresa }: IContext = useContext(Context);

  // A API não devolve email no /login: mostra a empresa e a filial
  const empresaFilial = dadosUsuario?.email || (empresa && `${empresa.raz} - ${empresa.fil}`);

  return (
    <Container>
      <Icon $imageURI={dadosUsuario?.imageURI}>
        {!dadosUsuario?.imageURI && <FaUser size={16} />}
      </Icon>
      <Info>
        <LoginUsuario title={dadosUsuario?.nome}>{dadosUsuario?.nome}</LoginUsuario>
        <Usuario title={empresaFilial || undefined}>{empresaFilial}</Usuario>
      </Info>
    </Container>
  )
}
